var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"fab":"","color":_vm.progressColor}},on),[_c('v-avatar',[_c('v-img',{attrs:{"src":_vm.icon(_vm.boss.abbr)}})],1)],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.boss.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }